export const LEGACY_SUBJECT_FALLBACK_CODE = 'LEGACY_SUBJECT_FALLBACK';

export const SUBJECT_CATALOG = [
  { key: 'computer-science-information', label: 'Computer Science & Information', icon: '💻', description: 'Programming, software and information systems.', accent: '#2563eb', query: 'computer OR programming OR software OR information' },
  { key: 'engineering-applied-technology', label: 'Engineering & Applied Technology', icon: '⚙️', description: 'Core engineering and applied technology resources.', accent: '#dc2626', query: 'engineering OR technology OR design' },
  { key: 'mathematics-natural-sciences', label: 'Mathematics & Natural Sciences', icon: '🔬', description: 'Mathematics, physics, chemistry and science titles.', accent: '#059669', query: 'mathematics OR physics OR chemistry OR science' },
  { key: 'social-sciences-management', label: 'Social Sciences & Management', icon: '📈', description: 'Economics, policy, management and society.', accent: '#0891b2', query: 'economics OR management OR sociology OR policy' },
  { key: 'literature-communication', label: 'Literature & Communication', icon: '📚', description: 'Literature, writing and communication studies.', accent: '#db2777', query: 'literature OR communication OR writing OR language' },
  { key: 'history-geography-biography', label: 'History, Geography & Biography', icon: '🗺️', description: 'History, places and biographies.', accent: '#0f766e', query: 'history OR biography OR geography OR travel' },
  { key: 'philosophy-psychology', label: 'Philosophy & Psychology', icon: '🧠', description: 'Thought, behavior and cognitive inquiry.', accent: '#7c3aed', query: 'philosophy OR psychology OR ethics' },
  { key: 'religion-culture', label: 'Religion & Culture', icon: '🕊️', description: 'Religion, traditions and cultural studies.', accent: '#c2410c', query: 'religion OR culture OR civilization' },
  { key: 'language-linguistics', label: 'Language & Linguistics', icon: '🗣️', description: 'Language learning, grammar and communication.', accent: '#4f46e5', query: 'language OR linguistics OR grammar' },
  { key: 'arts-design-recreation', label: 'Arts, Design & Recreation', icon: '🎨', description: 'Architecture, arts, design and recreation.', accent: '#d97706', query: 'arts OR design OR architecture OR sports' },
];

const SUBJECT_LOCALE_MAP = {
  'computer-science-information': {
    hi: 'कंप्यूटर विज्ञान और सूचना',
    te: 'కంప్యూటర్ సైన్స్ మరియు సమాచారం',
    aliases: ['computer science', 'sanganak', 'kampyutar', 'suchana', 'soochna', 'సంగణక'],
  },
  'engineering-applied-technology': {
    hi: 'अभियांत्रिकी और अनुप्रयुक्त प्रौद्योगिकी',
    te: 'ఇంజనీరింగ్ మరియు అనువర్తిత సాంకేతికత',
    aliases: ['engineering', 'yantriki', 'abhiyaantriki', 'ఇంజనీరింగ్'],
  },
  'mathematics-natural-sciences': {
    hi: 'गणित और प्राकृतिक विज्ञान',
    te: 'గణితం మరియు సహజ శాస్త్రాలు',
    aliases: ['ganit', 'ganitha', 'vigyan', 'vijnana', 'maths', 'science', 'గణితం'],
  },
  'social-sciences-management': {
    hi: 'सामाजिक विज्ञान और प्रबंधन',
    te: 'సామాజిక శాస్త్రాలు మరియు నిర్వహణ',
    aliases: ['samajik', 'prabandhan', 'management', 'society', 'సామాజిక'],
  },
  'literature-communication': {
    hi: 'साहित्य और संचार',
    te: 'సాహిత్యం మరియు కమ్యూనికేషన్',
    aliases: ['sahitya', 'sahityam', 'communication', 'కమ్యూనికేషన్'],
  },
  'history-geography-biography': {
    hi: 'इतिहास, भूगोल और जीवनी',
    te: 'చరిత్ర, భూగోళ శాస్త్రం మరియు జీవిత చరిత్ర',
    aliases: ['itihas', 'charitra', 'bhugol', 'history', 'geography', 'చరిత్ర'],
  },
  'philosophy-psychology': {
    hi: 'दर्शन और मनोविज्ञान',
    te: 'తత్వశాస్త్రం మరియు మనోవిజ్ఞానం',
    aliases: ['darshan', 'tatva', 'manovigyan', 'psychology', 'తత్వశాస్త్రం'],
  },
  'religion-culture': {
    hi: 'धर्म और संस्कृति',
    te: 'మతం మరియు సంస్కృతి',
    aliases: ['dharma', 'sanskriti', 'religion', 'culture', 'సంస్కృతి'],
  },
  'language-linguistics': {
    hi: 'भाषा और भाषाविज्ञान',
    te: 'భాష మరియు భాషావిజ్ఞానం',
    aliases: ['bhasha', 'bhasa', 'linguistics', 'language', 'భాష'],
  },
  'arts-design-recreation': {
    hi: 'कला, डिज़ाइन और मनोरंजन',
    te: 'కళలు, రూపకల్పన మరియు వినోదం',
    aliases: ['kala', 'kalalu', 'design', 'arts', 'కళ'],
  },
};

const TRANSLIT_REPLACEMENTS = [
  [/गणित|ganit|ganitha/gi, 'mathematics'],
  [/विज्ञान|vigyan|vijnana/gi, 'science'],
  [/कंप्यूटर|संगणक|kampyutar|sanganak/gi, 'computer'],
  [/अभियांत्रिकी|इंजीनियरिंग|abhiyaantriki|yantriki/gi, 'engineering'],
  [/साहित्य|sahitya|sahityam/gi, 'literature'],
  [/भाषा|bhasha|bhasa/gi, 'language'],
  [/इतिहास|itihas|charitra/gi, 'history'],
  [/धर्म|dharma/gi, 'religion'],
  [/दर्शन|darshan|tatva/gi, 'philosophy'],
];

export const normalizeSubjectSearch = (value = '') => {
  let normalized = String(value || '').toLowerCase();
  TRANSLIT_REPLACEMENTS.forEach(([pattern, replacement]) => {
    normalized = normalized.replace(pattern, ` ${replacement} `);
  });
  return normalized
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\p{L}\p{N}\s-]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const enrichSubjectMetadata = (subject = {}) => {
  const locale = SUBJECT_LOCALE_MAP[subject.key] || {};
  return {
    ...subject,
    labelHi: locale.hi || subject.label,
    labelTe: locale.te || subject.label,
    aliases: Array.isArray(locale.aliases) ? locale.aliases : [],
  };
};

export const localizedSubjectLabel = (subject = {}, locale = 'en') => {
  const enriched = enrichSubjectMetadata(subject);
  if (locale === 'hi') return enriched.labelHi || enriched.label || '';
  if (locale === 'te') return enriched.labelTe || enriched.label || '';
  return enriched.label || '';
};

export const parseSubjectJsonResponse = async (response, defaultMessage) => {
  if (!response.ok) {
    throw new Error(defaultMessage);
  }

  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    const body = await response.text();
    if (/<html|<!doctype/i.test(body)) {
      const fallbackError = new Error('Subject API is not available yet. Please restart the backend service and refresh this page.');
      fallbackError.code = LEGACY_SUBJECT_FALLBACK_CODE;
      throw fallbackError;
    }
    throw new Error('Unexpected response format received from server.');
  }

  return response.json();
};
